import React, {useEffect, useRef, useState} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useClickOutside } from '../../utils';
import cx from 'classnames';
import s from './index.module.css';

import {
    getIsUserAuthenticated,
    getCurrentMobileLayout,
    getIsMobile,
    getDialogsItems,
    getIsEmex,
    getActiveExpert,
    getIsLogoutModalOpened,
} from '../../store/selectors';
import { expertsActions, metaActions } from '../../store/actions';

import ExpertInfo from '../Header/ExpertInfo'
import AutorizationModal from '../AutorizationModal';
import LogoutPopup from '../LogoutPopup';
import ExpertCard from '../ExpertCard';
import Modal from '../Modal';
import { ReactComponent as AccountIcon } from '../../assets/icons/AccountIcon.svg';
import { ReactComponent as OrdersIcon } from '../../assets/icons/OrdersIcon.svg';
import { ReactComponent as NotificationIcon } from '../../assets/icons/NotificationIcon.svg';
import { ReactComponent as SmartbeLogo } from '../../assets/icons/SmartbeLogo.svg';

import { DEFAULT_TIME_TO_NEXT_CALL } from '../AutorizationModal/constants';
import { SAVED_LAYOUT_VALUE_KEY } from '../../constants/storageKeys';

const SMARTBE_CONNECT_TECH_LINK = 'https://smartbe.tilda.ws/?utm_source=emex&utm_medium=link&utm_campaign=logo/';
const DEFAULT_EMEX_LINK = 'https://emex.ru/';
const PART_REVIEW_LINK = 'https://partreview.ru';

// TODO: разделить view от model

const MobileHeader = ({ isEmex }) => {
    const savedMLayoutValue = sessionStorage.getItem(SAVED_LAYOUT_VALUE_KEY);
    const dispatch = useDispatch();
    const isLogOutPopupOpened = useSelector(getIsLogoutModalOpened);
    const mobileLayout = useSelector(getCurrentMobileLayout);
    const isAuthenticated = useSelector(getIsUserAuthenticated);
    const dialogs = useSelector(getDialogsItems);
    const isMobile = useSelector(getIsMobile);
    const activeExpert = useSelector(getActiveExpert);

    const currentMobileLayout = savedMLayoutValue || mobileLayout;

    const [timeToNextCall, setTimeToNextCall] = useState(DEFAULT_TIME_TO_NEXT_CALL);
    // TODO: убрал в глобальный стейт
    const [showExpertCardModal, setShowExpertCard] = useState(false);
    let loginButtonRef = useRef(null);
    let expertPanelRef = useRef(null);

    const isPartreview = window.location.pathname.includes('/partreview');
    const logoUrl = isPartreview ? PART_REVIEW_LINK : DEFAULT_EMEX_LINK;

    const isMobileChatActive = currentMobileLayout === 'chat';
    const isDialogListActive = currentMobileLayout === 'dialogs';
    const isOrdersLayoutActive = currentMobileLayout === 'orders';
    const isNotificationLayoutActive = currentMobileLayout === 'notification';

    const hasAcceptedDialogs = dialogs.some(item => item.expert_id !== null);
    const isShowSecondaryMobileHeader = isMobileChatActive || isOrdersLayoutActive || isNotificationLayoutActive;
    const isShowOrdersButton = isAuthenticated || hasAcceptedDialogs;
    const isShowBackButtonOnChat = isShowSecondaryMobileHeader && hasAcceptedDialogs &&
        !isOrdersLayoutActive;

    const [isShowNotificationButton, setShowNotificationButton] = useState(false);

    useEffect(() => {
      const timer = setTimeout(() => {
        setShowNotificationButton(true);
      }, 30000); // 30 секунд

      return () => clearTimeout(timer);
    }, []);

    const handleOpenAutorizationModal = (e) => {
        if (!isAuthenticated) {
            dispatch(metaActions.toggleAuthModal(true));
            return;
        }

        // TODO: убрать в глобальный стейт
        dispatch(metaActions.toggleLogoutModalOpen(!isLogOutPopupOpened));
    };

    const showExpertCard = () => {
        setShowExpertCard(!showExpertCardModal)
    };

    useClickOutside(loginButtonRef, (e) => {
        dispatch(metaActions.toggleLogoutModalOpen(false));
    });

    useClickOutside(expertPanelRef, (e) => {
        setShowExpertCard(false);
    });

    const handleOrdersOpen = () => {
        dispatch(metaActions.setCurrentMobileLayout('orders'));
    };

    const handleNotificationOpen = () => {
      console.log('handleNotificationOpen');
      dispatch(metaActions.setCurrentMobileLayout('notification'));
    };

    const handleBackButtonClick = () => {
        dispatch(metaActions.setCurrentMobileLayout('dialogs'));
        dispatch(expertsActions.setCallNewExpertButtonDisabled(false));
    };

    const backButton = <button
        className={s.backButton}
        onClick={handleBackButtonClick}
    >
        <span className={s.backButtonText}>К списку консультаций</span>
    </button>;

    const accountButton = <button
        className={s.accountButton}
        onClick={handleOpenAutorizationModal}
    >
        <AccountIcon />
    </button>;

    const ordersButton = <button
        className={s.ordersButton}
        onClick={handleOrdersOpen}
    >
        <OrdersIcon />
    </button>;

    const notificationsButton = <button
      className={s.notificationsButton}
      onClick={handleNotificationOpen}
    >
      <NotificationIcon />
    </button>;

    const primaryHeaderLogoSmartbe = <a
        target='_self'
        className={cx(s.navigation, s.logo, s.smartbeLogo)}
        href="/"></a>;

    const primaryHeaderLogoEmex = (
        <div className={s.primaryHeaderLogo}>
            <div className={s.logoWrapper}>
                <div className={s.emexLogoWrapper}>
                    <a href={logoUrl}>
                        <div className={s.emexLogo}></div>
                    </a>
                </div>
                <a className={s.smartbeLabelBox}
                    href={isEmex ? SMARTBE_CONNECT_TECH_LINK : '/Business'}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <div className={s.smartbeLabel}>Работает на технологии</div>
                    <SmartbeLogo className={s.smartbeLogoEmex} />
                </a>
            </div>
        </div>
    );

    const primaryMobileHeaderEmex = (
        <div className={s.primaryMobileHeaderWrapper}>
            {primaryHeaderLogoEmex}
            <div
                className={s.primaryHeaderMenu}
                ref={loginButtonRef}
            >
                {accountButton}
                {isLogOutPopupOpened && (
                    <LogoutPopup
                        isMobile={isMobile}
                        isAuthenticated={isAuthenticated} />
                )}
                {isShowOrdersButton && ordersButton}
                {isShowNotificationButton && notificationsButton}
            </div>
        </div>
    );

    const primaryMobileHeaderSmartbe = (
        <div className={s.primaryMobileHeaderWrapper}>
            {primaryHeaderLogoSmartbe}
            <div
                className={s.primaryHeaderMenu}
                ref={loginButtonRef}
            >
                {accountButton}
                {isLogOutPopupOpened && (
                    <LogoutPopup
                        isMobile={isMobile}
                        isAuthenticated={isAuthenticated} />
                )}
                {isShowOrdersButton && ordersButton}
                {isShowNotificationButton && notificationsButton}
            </div>
        </div>
    );

    const expertPanel = (
        <div
            className={s.expertPanel}
            onClick={showExpertCard}
            ref={expertPanelRef}
        >
            <ExpertInfo isMobile={isMobileChatActive} />
            {showExpertCardModal && (
                <Modal
                    className={s.expertModal}
                    showClose={false}
                    overlayClassName={s.expertModalOverlay}
                    isPortal={false}
                    withOverlay={false}
                >
                    <ExpertCard className={s.expertCard} card={activeExpert} />
                </Modal>
            )}
        </div>
    );

    const secondaryMobileHeader = (
        <div className={cx(s.secondaryMobileHeaderWrapper,
            { [s.withoutPadding]: !isShowBackButtonOnChat })}
        >
            <div className={s.secondaryMobileHeader}>
                {isMobileChatActive && (
                    <div className={s.topPanelWithExpert}>
                        {expertPanel}
                        {isShowBackButtonOnChat && backButton}
                    </div>
                )}
            </div>
        </div>
    );

    const ordersLayoutHeader = (
        <div className={s.orderPanel}>
            {backButton}
        </div>
    );

  const notificationLayoutHeader = (
      <div className={s.notificationPanel}>
        {backButton}
      </div>
  );

    return (
        <div className={s.mobileHeaderWrapper}>
            <AutorizationModal
                className={s.modal}
                timeToNextCall={timeToNextCall}
                setTimeToNextCall={setTimeToNextCall}
                showClose
                isPortal />
            {isEmex ? primaryMobileHeaderEmex : primaryMobileHeaderSmartbe}
            {isShowSecondaryMobileHeader && secondaryMobileHeader}
            {isOrdersLayoutActive && ordersLayoutHeader}
            {isNotificationLayoutActive && notificationLayoutHeader}
        </div>
    );
};

export default MobileHeader;
